module.exports = "<div class=\"ui stackable four column grid\">\n  <location-row\n    *ngFor=\"let location of sortedLocations()\"\n    [location]=\"location\"\n    (click)='clicked(location)'\n    [class.selected]=\"isSelected(location)\">\n  </location-row>\n \n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/locations-list/locations-list.component.html
// module id = ./src/app/locations-list/locations-list.component.html
// module chunks = main